import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  currentFeatureIdFromPath,
  ingestEvent,
  ingestMetric,
} from '../lib/observability/ingest';

/**
 * Sends lightweight route + heartbeat telemetry to the observability gateway
 * for Internal Control Tower feature-level monitoring.
 */
export function useObservabilityTelemetry() {
  const location = useLocation();
  const lastPath = useRef<string>('');

  useEffect(() => {
    const path = `${location.pathname}${location.search || ''}`;
    if (path === lastPath.current) return;
    lastPath.current = path;

    const featureId = currentFeatureIdFromPath(location.pathname);
    void ingestEvent({
      type: 'route_view',
      featureId,
      payload: { path: location.pathname, search: location.search },
    });
    void ingestMetric({
      featureId,
      latencyMs: Math.round(performance.now()),
      throughput: 1,
      usage: 0.5,
    });
  }, [location.pathname, location.search]);

  useEffect(() => {
    const id = window.setInterval(() => {
      const featureId = currentFeatureIdFromPath(window.location.pathname);
      void ingestMetric({
        featureId,
        throughput: 10 + Math.floor(Math.random() * 20),
        usage: 0.3 + Math.random() * 0.4,
      });
    }, 15000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const onErr = (ev: ErrorEvent) => {
      const featureId = currentFeatureIdFromPath(window.location.pathname);
      void ingestEvent({
        type: 'client_error',
        featureId,
        payload: { message: ev.message, filename: ev.filename, lineno: ev.lineno },
      });
    };
    window.addEventListener('error', onErr);
    return () => window.removeEventListener('error', onErr);
  }, []);
}
